import { defineStore } from "pinia";
import { bff } from "boot/bff-client";

export const useBffSettingsStore = defineStore("bffSettingsStore", {
  state: () => ({
    bffSettingId: null,
    settings: {},
  }),

  getters: {
    getInitialized(state) {
      return !!state.bffSettingId;
    },
    getSettings(state) {
      return state.settings;
    },
    getSetting: (state) => (path) => {
      const keys = path.split(".");
      let current = state.settings;
      for (let key of keys) {
        if (!current[key]) {
          return undefined;
        }
        current = current[key];
      }
      return current;
    },
  },

  actions: {
    async loadSettings() {
      console.log("@@@ bffSettings loading...");
      const response = await bff.bffSettings.getUserSettings();
      console.log("@@@ bffSettings response:", response);

      if (response) {
        this.bffSettingId = response.bffSettingId;
        this.settings = {
          ...response.settings,
        };
      }
    },
    async saveSettings() {
      const bffSettings = this.settings;
      const id = this.bffSettingId || undefined;
      const response = await bff.bffSettings.saveUserSettings(
        bffSettings,
        id
      );
      if (response && response.bffSettingId) {
        this.bffSettingId = response.bffSettingId;
      }
    },
    setSetting({ path, value }) {
      const keys = path.split(".");
      let current = this.settings;
      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!current[key]) {
          current[key] = {};
        }
        current = current[key];
      }
      const lastKey = keys[keys.length - 1];
      current[lastKey] = value;
    },
  },
});
